import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SMS Prime PWA: Service Worker registered successfully:', registration.scope);
        
        // Listen for service worker updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker installed, notify user about update
                console.log('SMS Prime PWA: New version available');
                if (window.confirm('A new version of SMS Prime is available. Reload to update?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          }
        });
        
        // Listen for controlling service worker change
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('SMS Prime PWA: Controller changed, reloading page');
          window.location.reload();
        });
        
        // Listen for messages from service worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          const { type, data } = event.data;
          
          switch (type) {
            case 'SYNC_SUCCESS':
              console.log('SMS Prime PWA: Background sync successful');
              // Could show a success notification to the user
              break;
              
            case 'OFFLINE_FORM_SAVED':
              console.log('SMS Prime PWA: Form saved offline');
              // Could show offline indicator to the user
              break;
              
            default:
              console.log('SMS Prime PWA: Unknown message from service worker:', type, data);
          }
        });
      })
      .catch((error) => {
        console.error('SMS Prime PWA: Service Worker registration failed:', error);
      });
  });
}

// Add PWA install prompt handling
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('SMS Prime PWA: Install prompt available');
  e.preventDefault();
  deferredPrompt = e;
  
  // Could show custom install button here
  const installButton = document.getElementById('pwa-install-button');
  if (installButton) {
    installButton.style.display = 'block';
    installButton.addEventListener('click', () => {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('SMS Prime PWA: User accepted the install prompt');
        } else {
          console.log('SMS Prime PWA: User dismissed the install prompt');
        }
        deferredPrompt = null;
        installButton.style.display = 'none';
      });
    });
  }
});

// Track if app was launched as PWA
window.addEventListener('appinstalled', (evt) => {
  console.log('SMS Prime PWA: App was installed');
});

// Handle network status changes
window.addEventListener('online', () => {
  console.log('SMS Prime PWA: Back online');
  // Could trigger sync or show online indicator
});

window.addEventListener('offline', () => {
  console.log('SMS Prime PWA: Gone offline');
  // Could show offline indicator
});
